// @flow
import { Formik } from 'formik';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Form } from '../../formik-utils/formikSUIWrapper';
import { StyledContainer } from '../../common-utils/styledComponents';
import { getFormikFormInputsFromColConfigAndInputSource } from '../../common-utils/utils';
import { ESTIMATE_ACCOUNT_DETAILS_CONFIG } from '../../configuration/estimate-account-details';
import { IS_FEDRAMP_LIVE_IN_CE1 } from '../../constants';
import { EstimateAccountDetailsGrid } from '../estimate-account-details/EstimateAccountDetailsGrid';
import { FedRAMPEnabledContainer } from '../fedramp/FedRAMPEnabledContainer';
import { FEDRAMP_ENABLED_BACKEND_NAME } from '../fedramp/constants';
import { ConfirmModal } from '../presentational/modals/ConfirmModal';
import { useAddEstimateMutation } from '../../service-definitions/estimates';
import { toastError } from '../presentational/notifications/utils';
import { Spacer } from '../presentational/spacing/Spacer';

export const EstimateAddModal = ({ defaultValues, isOpen, onClose }) => {
  const [addEstimate] = useAddEstimateMutation();
  const { push } = useHistory();
  const [isFedRAMPConfirmModalOpen, setFedRAMPConfirmModalOpen] = useState(false);

  const { initialValues, validationSchema } = getFormikFormInputsFromColConfigAndInputSource(
    ESTIMATE_ACCOUNT_DETAILS_CONFIG,
    defaultValues,
    null
  );

  const initialValuesToUse = IS_FEDRAMP_LIVE_IN_CE1
    ? { ...initialValues, [FEDRAMP_ENABLED_BACKEND_NAME]: false }
    : initialValues;

  const createEstimate = async (values) => {
    const { error, data } = await addEstimate({ ...values });

    if (error) {
      toastError(error);
    } else {
      push(`/estimate/${data.id}`);
    }
    onClose();
  };

  return (
    <StyledContainer data-testid="estimate-add-modal">
      <Formik
        autoComplete="off"
        initialValues={initialValuesToUse}
        onSubmit={() => {}}
        validationSchema={validationSchema}
      >
        {(addEstimateFormik) => (
          <>
            <ConfirmModal
              body={
                <StyledContainer>
                  <Form autoComplete="off">
                    <EstimateAccountDetailsGrid disableOnFormErrors={false} />
                  </Form>
                  <FedRAMPEnabledContainer />
                  <Spacer y={40} />
                  Note: All fields are mandatory!
                </StyledContainer>
              }
              cancelButtonNegative={true}
              disabled={!addEstimateFormik.dirty || !addEstimateFormik.isValid}
              header="Add New Estimate"
              isOpen={isOpen}
              okButtonNegative={false}
              okButtonText="Continue"
              onClickHandlerForCancel={onClose}
              onClickHandlerForOK={() => {
                // FedRAMP can't be changed after creation, so confirm opt-in before creating.
                if (addEstimateFormik.values[FEDRAMP_ENABLED_BACKEND_NAME] === true) {
                  setFedRAMPConfirmModalOpen(true);
                } else {
                  createEstimate(addEstimateFormik.values);
                }
              }}
            />
            <ConfirmModal
              body="This estimate will be created in FedRAMP mode, which cannot be changed later. Do you want to continue?"
              cancelButtonNegative={true}
              cancelButtonText="Cancel"
              header="Enable FedRAMP mode?"
              isOpen={isFedRAMPConfirmModalOpen}
              okButtonNegative={false}
              okButtonText="Confirm"
              onClickHandlerForCancel={() => setFedRAMPConfirmModalOpen(false)}
              onClickHandlerForOK={() => {
                setFedRAMPConfirmModalOpen(false);
                createEstimate(addEstimateFormik.values);
              }}
            />
          </>
        )}
      </Formik>
    </StyledContainer>
  );
};

// todo:: Think about separating out the page into multiple smaller forms
